"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Divider, Space } from "antd";
import { DownloadOutlined, EyeOutlined, GithubOutlined } from "@ant-design/icons";
import { OutsideLink } from "@/components/OutsideLink";
import { url_resume_pdf_mirror, url_resume_pdf_release, url_resume_pdf_source } from "@/data";
import { useLocale, useTranslations } from "next-intl";
import styles from "./page.module.sass";

/**
 * Stays a client component: antd's package barrel calls `createContext` at module
 * evaluation time, which throws when imported from a server component.
 */
export default function ResumePage(_props) {
  const $ = _c(36);
  const locale = useLocale();
  const t = useTranslations("resume");
  const resumePdfUrl = `${url_resume_pdf_mirror}?locale=${locale}`;
  let t0;
  if ($[0] !== t) {
    t0 = t("title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h1 className={styles.title}>{t0}</h1>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider data-sentry-element="Divider" data-sentry-source-file="page.tsx" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DownloadOutlined />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("download");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <Button type="primary" icon={t3} data-sentry-element="Button" data-sentry-source-file="page.tsx">{t4}</Button>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== resumePdfUrl || $[11] !== t5) {
    t6 = <OutsideLink href={resumePdfUrl} data-sentry-element="OutsideLink" data-sentry-source-file="page.tsx">{t5}</OutsideLink>;
    $[10] = resumePdfUrl;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <GithubOutlined />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("downloadGithub");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <OutsideLink href={url_resume_pdf_release} data-sentry-element="OutsideLink" data-sentry-source-file="page.tsx"><Button type="primary" ghost={true} icon={t7} data-sentry-element="Button" data-sentry-source-file="page.tsx">{t8}</Button></OutsideLink>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <EyeOutlined />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("viewSource");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <OutsideLink href={url_resume_pdf_source} data-sentry-element="OutsideLink" data-sentry-source-file="page.tsx"><Button type="default" icon={t10} data-sentry-element="Button" data-sentry-source-file="page.tsx">{t11}</Button></OutsideLink>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t6 || $[25] !== t9) {
    t13 = <Space wrap={true} size="large" data-sentry-element="Space" data-sentry-source-file="page.tsx">{t6}{t9}{t12}</Space>;
    $[23] = t12;
    $[24] = t6;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("title");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== resumePdfUrl || $[30] !== t14) {
    t15 = <div className={styles.resume}><iframe className={styles.resume_embed} src={resumePdfUrl} title={t14} /></div>;
    $[29] = resumePdfUrl;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t1 || $[33] !== t13 || $[34] !== t15) {
    t16 = <div className={styles.container} data-sentry-component="ResumePage" data-sentry-source-file="page.tsx"><main>{t1}{t2}{t13}{t15}</main></div>;
    $[32] = t1;
    $[33] = t13;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}